<template>
    <Box title="配件搜索">
        <div class="inputBox">
            <img src="../../assets/img/search.png"/>
            <input type="text" @input="inputValue" placeholder="搜索"/>
        </div>
        <div class="itemBox">
            <div class="items" v-for="(item,index) in PartsList">
                <p>{{item.SBMC}}</p>
                <div v-if="!Accessories_Repertory">
                    <p>库存数量:{{item.SL}}</p>
                    <p style="float: right;text-align: right;">库存虚数量:{{item.XSL}}</p>
                </div>
                <div>
                    <span class="ellipsis">规格： {{item.GGXH}}</span>
                    <span class="ellipsis">单位： {{item.DW}}</span>
                    <span class="ellipsis">¥{{item.DJ||0}}</span>
                    <van-stepper @change="change(arguments, index)" :min="0" default-value='0' integer   input-width="25px" button-size="20px"
                     :max="!Accessories_Repertory?99:item.SL>=item.XSL?item.XSL:item.SL"/>
                </div>
            </div>
        </div>
        <Footer button="添加" @change="Submit"/>
    </Box>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import {Stepper} from 'vant'
    import Footer from '../../components/footer/footer'
    export default {
        name: 'AccessoriesSearch',
        components: {
            Box,
            [Stepper.name]: Stepper,
            Footer,
        },
        data() {
            return {
            PartsList:[],//数据库配件集合
            outTime:0,
            Accessories_Repertory:false,
            AccessoriesArray:[],//选中的配件
            }
        },
        mounted(){
           this.loadDataDefault('');
        },
        methods: {
            // emit(item) {
            //     Bus.$emit('selectAccessories', item)
            //     this.$router.back()
            // },
            change(nums,index) {
                let Index=this.AccessoriesArray.findIndex(x=>x.index===index);
                if(nums[0]===0){
                    this.AccessoriesArray.splice(Index,1);
                }else{
                    if(Index===-1){
                        let data=this.PartsList[index];
                        data.index=index;
                        data.SYSL=nums[0];
                        this.AccessoriesArray.push(data);
                    }else{
                        this.AccessoriesArray[Index].SYSL=nums[0];
                    }
                }

            },loadDataDefault(inpuvalue){
                this.$get('api/Dispatch/GetAccessoriesList',{
                    limit:10,
                    q:inpuvalue?inpuvalue:'',
                    STORE:this.$UserInfo.StoreCode
                }).then(result=>{
                    this.Accessories_Repertory=result.Accessories_Repertory;
                    this.PartsList=result.model;
                })
            },inputValue(value){
                let inputValue=value.target.value;
                if (this.outTime == 0) {
                    this.outTime = setTimeout(() => {
                        this.loadDataDefault(inputValue);
                    }, 1500)
                } else {
                    clearTimeout(this.outTime)
                    this.outTime = setTimeout(() => {
                        this.loadDataDefault(inputValue);
                    }, 1500)
                }
            },Submit(){
                if(this.AccessoriesArray.length===0){
                    this.$Toast('请选择配件数量!');
                    return false;
                }
                this.$Bus.$emit('selectAccessories',this.AccessoriesArray)
                this.$router.back()
            }
        },
    }
</script>

<style scoped lang="scss">
    .inputBox{
        height: 86px;
        display: flex;
        align-items: center;
        background: #369189;
        border-radius: 10px;
        padding: 0 30px;
        box-sizing: border-box;
        img{
            width: 30px;
        }
        input{
            margin-left: 26px;
            font-size: 29px;
            color: #fff;
            flex: 1;
            &::-webkit-input-placeholder{
                color: rgba(255,255,255,.35);
            }
        }
    }
    .itemBox{
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 0 40px;
        margin-top: 20px;
        .items{
            /*height: 112px;*/
            border-bottom: 2px solid #f3f3f3;
            padding: 20px 0;
            p{
                color: $TEXT-DARK-COLOR;
                width: 50%;
                font-size: 28px;
                margin-bottom: 10px;
            }
            div{
                display: flex;
                align-items: center;
                span{
                    color: #999;
                    font-size: 26px;
                    flex: 1;
                    text-align: left;
                    &:nth-child(2),&:nth-child(3) {
                        text-indent: 10px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/accessoriesSearch/accessoriesSearch.vue